import { render, staticRenderFns } from "./refusal.vue?vue&type=template&id=156bff28&scoped=true&"
import script from "./refusal.vue?vue&type=script&lang=js&"
export * from "./refusal.vue?vue&type=script&lang=js&"
import style0 from "./refusal.vue?vue&type=style&index=0&id=156bff28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156bff28",
  null
  
)

export default component.exports